<template>
  <v-container>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex xs12>
          <h1>App Content</h1>
        </v-flex>
        <v-flex xs12>
          <v-tabs dark>
            <v-tabs-slider color="red"></v-tabs-slider>
            <v-tab :to="{ name: 'Specials' }">
              Specials
            </v-tab>
            <v-tab :to="{ name: 'Notifications' }">
              Notifications
            </v-tab>
            <v-tab :to="{ name: 'Gallery' }">
              Gallery
            </v-tab>
            <v-tab :to="{ name: 'Information' }">
              Information
            </v-tab>
            <v-tab :to="{ name: 'Instructors' }">
              Instructors
            </v-tab>
            <v-tab :to="{ name: 'Schedule' }">
              Schedule
            </v-tab>
            <v-tab :to="{ name: 'UpcomingEvents' }">
              Upcoming Events
            </v-tab>
          </v-tabs>
          <v-card flat>
            <v-card-text>
              <router-view></router-view>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
  export default {
    data() {
      return {

      };
    }
  };
</script>